import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    CheckCircleOutline,
    ErrorOutline,
    Search,
    TrendingUp,
    MonetizationOn,
    WarningAmber,
    StarBorder,
    Apartment,
    Person,
    ThumbUpAlt,
    ThumbDownAlt,
    Lightbulb,
    Room,
    PeopleAlt
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3, pb: 6 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアの「敷金・礼金ゼロ」物件とは
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('search-tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    敷金・礼金ゼロ物件を探すコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('merit-demerit')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    メリット・デメリット徹底比較
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('attention')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    注意すべきポイントとトラブル回避術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experience')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    体験談：実際に住んでみて感じたこと
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ・おすすめの一歩
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアの「敷金・礼金ゼロ」物件とは
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    初期費用を抑えて新生活を始めたい。そんな方に人気なのが「敷金・礼金ゼロ」のルームシェア物件です。<b>敷金・礼金不要</b>の物件は、特に若い世代や転勤・留学などで短期滞在を考えている方にとって、経済的にも精神的にもハードルが低い選択肢となっています。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    とはいえ、「本当にお得なの？」「トラブルはないの？」と心配の声もよく聞かれます。本記事では、「敷金・礼金ゼロ」物件の探し方やメリット・デメリット、失敗しないための注意点、そして実際の体験談まで、徹底的に解説します。
                </Typography>
                <Box sx={{ my: 3, textAlign: 'center' }}>
                    <img
                        src="/images/blog/roommates-dining_roomshare-shikikin-reikin-zero-tips.jpg"
                        alt="明るい共有リビングで多国籍なルームメイトたちが食卓を囲み、リラックスした雰囲気で会話を楽しんでいる様子。木製テーブルと観葉植物が温かな印象を与えている。"
                        style={{ width: '100%', maxWidth: 600, borderRadius: 10, objectFit: 'cover', boxShadow: '0 4px 16px rgba(0,0,0,0.08)' }}
                    />
                </Box>
                <Typography variant="body2" color="text.secondary">
                    この記事を読めば、ルームシェアの「敷金・礼金ゼロ」物件選びに自信が持てるはずです！
                </Typography>
            </Box>

            {/* 探し方 */}
            <Box id="search-tips" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    敷金・礼金ゼロ物件を探すコツ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            「敷金・礼金ゼロ」のルームシェア物件は、<b>探し方にコツ</b>があります。単なる検索ワードだけでなく、狙い目の時期やエリア、問い合わせ時の注意点も押さえておきましょう。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <Search color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="検索サイトでの絞り込み"
                                    secondary="大手賃貸サイトやルームシェア専門サイトで『敷金礼金なし』『初期費用ゼロ』などのキーワードで絞り込みましょう。"
                                />
                            </ListItem>

                            <ListItem>
                                <ListItemIcon>
                                    <TrendingUp color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="春・秋の繁忙期直後を狙う"
                                    secondary="3〜4月、9〜10月の入居ラッシュ後は、空室を埋めるために初期費用ゼロのキャンペーンが増えます。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <Person color="primary" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="直接オーナーに交渉"
                                    secondary="ネット掲載情報だけでなく、直接問い合わせてみると条件交渉できる場合も。"
                                />
                            </ListItem>
                        </List>
                        <Box sx={{ mt: 2 }}>
                            <Chip label="初期費用ゼロ" color="primary" variant="outlined" sx={{ mr: 1 }} />
                            <Chip label="敷金礼金なし" color="primary" variant="outlined" sx={{ mr: 1 }} />
                            <Chip label="キャンペーン物件" color="primary" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>

                        </Box>
                    </Grid>
                </Grid>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
                    物件探しは「スピードと情報量」が勝負。気になる物件は早めに問い合わせましょう！
                </Typography>
            </Box>

            {/* メリット・デメリット */}
            <Box id="merit-demerit" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    メリット・デメリット徹底比較
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 3, borderRadius: 2, bgcolor: '#f0f9ec' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <ThumbUpAlt color="success" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ color: 'success.main' }}>メリット</Typography>
                            </Box>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleOutline color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="初期費用を大幅カット"
                                        secondary="敷金・礼金がないので、引越し時の負担が格段に少なくなります。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <MonetizationOn color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="短期間でも住みやすい"
                                        secondary="長期契約が不要な場合も多く、数ヶ月だけの利用にも最適です。"
                                    />
                                </ListItem>

                                <ListItem>
                                    <ListItemIcon>
                                        <Lightbulb color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="住み替え・お試しに最適"
                                        secondary="「エリアや住み心地を試したい」という人にもおすすめ。"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 3, borderRadius: 2, bgcolor: '#fff4f2' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <ThumbDownAlt color="error" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ color: 'error.main' }}>デメリット</Typography>
                            </Box>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorOutline color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="退去時の原状回復費用が高額なケースも"
                                        secondary="敷金がない代わりに、退去時に別途請求されることがあります。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <WarningAmber color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="初期費用以外の名目で費用がかかる場合"
                                        secondary="クリーニング費や保証料など、別の名目で初期費用が発生することも。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Room color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="物件数が限定的"
                                        secondary="立地や条件によっては選択肢が少ないことも。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <StarBorder color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="入居審査がやや厳しい場合も"
                                        secondary="トラブル防止のため、独自の審査基準を設けている物件もあります。"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, textAlign: 'center' }}>

                </Box>
            </Box>

            {/* 注意点 */}
            <Box id="attention" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    注意すべきポイントとトラブル回避術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    敷金・礼金ゼロ物件は魅力的ですが、契約や入居後に「こんなはずじゃなかった…」と後悔しないために、以下のポイントを必ずチェックしましょう。
                </Typography>
                <Paper elevation={1} sx={{ p: 3, borderRadius: 2, bgcolor: '#fffde7', mb: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                        <WarningAmber color="warning" sx={{ mr: 1 }} />
                        チェックポイント
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon>
                                <ErrorOutline color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="退去時の費用明細を事前に確認"
                                secondary="原状回復費、クリーニング代、追加費用の有無を契約書でしっかりチェック。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <MonetizationOn color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="初期費用以外の費用総額を把握"
                                secondary="保証料や鍵交換代など、別途発生する費用の有無を確認しましょう。"
                            />
                        </ListItem>

                        <ListItem>
                            <ListItemIcon>
                                <Room color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="共用部の使い方や設備状況"
                                secondary="キッチン・バス・トイレなどの清掃ルールや設備の状態を内見時に要確認。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" color="text.secondary">
                    気になることは「聞きづらい…」と思わず、納得できるまで質問するのが失敗回避のコツです。
                </Typography>
            </Box>

            {/* 体験談 */}
            <Box id="experience" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    体験談：実際に住んでみて感じたこと
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Card sx={{ maxWidth: 600, mx: 'auto', mb: 3, bgcolor: '#f3e5f5', borderRadius: 3 }}>
                    <CardContent>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            <b>「敷金・礼金ゼロで都心のルームシェアへ」</b>
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            20代女性・会社員
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            転職を機に、都内のルームシェア物件（敷金礼金ゼロ）に引っ越しました。引越し費用が本当に安く済み、家具家電付きだったので初日から快適！ただ、退去時にクリーニング代が想定より高額だったのは少し驚きました。契約書をもっと細かく見ておけばよかったと思っています。
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            <StarBorder fontSize="small" sx={{ color: '#7b1fa2', mr: 0.5, verticalAlign: 'middle' }} />
                            ポイント：<b>「初期費用ゼロでも、退去費用と契約内容は要チェック！」</b>
                        </Typography>
                    </CardContent>
                </Card>
                <Card sx={{ maxWidth: 600, mx: 'auto', bgcolor: '#e1f5fe', borderRadius: 3 }}>
                    <CardContent>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            <b>「友達ができて、生活が一変」</b>
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            30代男性・フリーランス
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            地方から上京し、初期費用を抑えたくて敷金・礼金ゼロ物件でルームシェア開始。ルームメイトとすぐに仲良くなり、今では一緒にイベントに出かけることも。人とのつながりができ、独り暮らしでは味わえない日常が広がりました。
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            <PeopleAlt fontSize="small" sx={{ color: '#0288d1', mr: 0.5, verticalAlign: 'middle' }} />
                            ポイント：<b>「コミュニケーションの広がりはルームシェアならでは！」</b>
                        </Typography>
                    </CardContent>
                </Card>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ・おすすめの一歩
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    敷金・礼金ゼロ物件でのルームシェアは、<b>経済的なメリット</b>だけでなく、新しい人との出会いや柔軟な住み替えにもぴったり。ただし、「本当にゼロなのか？」の裏側まで契約書でしっかり確認し、納得のうえで選ぶことが大切です。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    最後に、物件選びで迷ったら専門サイトや経験者の口コミも積極的に活用しましょう。<b>「安さ」と「安心」を両立できる理想のルームシェア生活</b>を、ぜひ実現してください！
                </Typography>
                <Box sx={{ mt: 3, textAlign: 'center' }}>

                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-shikikin-reikin-zero-tips',
    slug: 'roomshare-shikikin-reikin-zero-tips',
    title: 'ルームシェアの「敷金・礼金ゼロ」物件を探すコツ',
    excerpt: 'ルームシェアで初期費用を抑える「敷金・礼金ゼロ」物件の探し方やメリット・デメリット、注意点、体験談まで徹底解説。',
    coverImage: '/images/blog/cover-roomshare-shikikin-reikin-zero_roomshare-shikikin-reikin-zero-tips.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。温かみのある木製家具と観葉植物が快適な共同生活の雰囲気を表現している。',
    publishedAt: '2024-06-07T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '賃貸・初期費用', '住まいの知恵'],
    tags: ['敷金ゼロ', '礼金ゼロ', 'ルームシェア', '物件探し', '初期費用'],
    author: {
        name: '三浦 友紀',
        avatar: '/images/avatars/miura-yuki.jpg',
        bio: '不動産業界で10年以上の経験を持ち、住まい選びとルームシェアの最新トレンドに精通。丁寧かつ具体的なアドバイスが好評。',
        profilePicture: '/images/avatars/miura-yuki.jpg'
    },
    viewCount: 1650,
    contentComponent: PostContent
};

export default post;